/** Ключи запросов генераций. Пользователь в ключ не входит: при смене аккаунта кэш
 *  очищается целиком (`qc.clear()` во входе, выходе и регистрации). */
export const generationKeys = {
  all: ['generations'] as const,
  /** Бесконечный список, страница — 10 записей. */
  list: () => ['generations', 'list'] as const,
  /** Запасной опрос первой страницы — отдельный запрос, чтобы не перечитывать все страницы. */
  head: () => ['generations', 'head'] as const,
  byId: (id: string) => ['generations', 'detail', id] as const,
};
